const thetopView = (() => {
  if (document.querySelector("body#pageThetop") !== null) {



    let secView = document.querySelector('#jsSecView');
    let viewWrap = secView.querySelector('.js-view-wrap');

    let tabimgBox = viewWrap.querySelector('.js-tabimg-box');
    let imgs = tabimgBox.querySelectorAll('.js-img');

    let tabbtnBox = viewWrap.querySelector('.js-tabbtn-box');
    let btns = tabbtnBox.querySelectorAll('.js-btn');


    imgs[0].classList.add('is-act');

    btns.forEach((element, index) => {
      element.addEventListener('click', () => {

        for (let i = 0; i < btns.length; i++) {
          // btns[i].classList.remove('is-act');
          imgs[i].classList.remove('is-act');
        }

        imgs[index].classList.add('is-act');

      });
    });




  }
})()
export default thetopView;